module.exports = __webpack_public_path__ + "static/media/1013706.82ccbd32.jpg";